document.addEventListener('DOMContentLoaded', () => {
  const overlay    = document.querySelector('[data-ccd-overlay]');
  const drawer     = document.querySelector('[data-ccd-drawer]');
  const closeBtn   = document.querySelector('[data-ccd-close]');
  const itemsWrap  = document.querySelector('[data-ccd-items]');
  const subtotalEl = document.querySelector('[data-ccd-subtotal]');
  const checkoutBtn = document.querySelector('[data-ccd-checkout]');

  if (!overlay || !drawer) return;

  const formatMoney = (amount) => {
    // amount in cents
    return '$' + (amount / 100).toFixed(0);
  };

  function openDrawer() {
    overlay.classList.add('is-open');
    document.documentElement.classList.add('ccd-lock-scroll');
    document.body.classList.add('ccd-lock-scroll');
  }

  function closeDrawer() {
    overlay.classList.remove('is-open');
    document.documentElement.classList.remove('ccd-lock-scroll');
    document.body.classList.remove('ccd-lock-scroll');
  }

  function renderCart(cart) {
    if (!cart || !itemsWrap) return;

    if (!cart.items.length) {
      itemsWrap.innerHTML = '<p class="ccd-empty">Your cart is empty.</p>';
    } else {
      let html = '';
      cart.items.forEach((item, index) => {
        const line = index + 1;
        const variantTitle =
          item.variant_title && item.variant_title !== 'Default Title'
            ? item.variant_title
            : '';

        html += `
          <div class="ccd-item" data-line="${line}">
            <div class="ccd-item-left">
              <a href="${item.url}" class="ccd-thumb">
                ${
                  item.image
                    ? `<img src="${item.image}" alt="${item.product_title}">`
                    : ''
                }
              </a>
              <div class="ccd-item-text">
                <p class="ccd-item-title">${item.product_title}</p>
                ${
                  variantTitle
                    ? `<p class="ccd-item-variant">${variantTitle}</p>`
                    : ''
                }
                <div class="ccd-item-qty-row">
                  <button type="button" class="ccd-qty-btn" data-ccd-qty-minus>-</button>
                  <span class="ccd-qty-value">${item.quantity}</span>
                  <button type="button" class="ccd-qty-btn" data-ccd-qty-plus>+</button>
                </div>
                <button type="button" class="ccd-remove" data-ccd-remove>
                  Remove
                </button>
              </div>
            </div>
            <div class="ccd-item-price">
              ${formatMoney(item.final_line_price)}
            </div>
          </div>
        `;
      });

      itemsWrap.innerHTML = html;
    }

    if (subtotalEl) {
      subtotalEl.textContent = formatMoney(cart.total_price);
    }

    attachItemListeners();
  }

  function attachItemListeners() {
    itemsWrap.querySelectorAll('.ccd-item').forEach((row) => {
      const line = Number(row.dataset.line);
      if (!line) return;

      const minusBtn = row.querySelector('[data-ccd-qty-minus]');
      const plusBtn  = row.querySelector('[data-ccd-qty-plus]');
      const removeBtn = row.querySelector('[data-ccd-remove]');

      if (minusBtn) {
        minusBtn.addEventListener('click', () => changeQty(line, -1));
      }
      if (plusBtn) {
        plusBtn.addEventListener('click', () => changeQty(line, +1));
      }
      if (removeBtn) {
        removeBtn.addEventListener('click', () => setQty(line, 0));
      }
    });
  }

  function fetchCartAndOpen() {
    fetch('/cart.js')
      .then((res) => res.json())
      .then((cart) => {
        renderCart(cart);
        openDrawer();
      })
      .catch((err) => console.error('Fetch cart error', err));
  }

  function setQty(line, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line, quantity }),
    })
      .then((res) => res.json())
      .then((cart) => {
        renderCart(cart);
        updateHeaderCartBubble(); // <-- This is the correct place
      })
      .catch((err) => console.error('Change qty error', err));
  }

  function changeQty(line, delta) {
    const row = itemsWrap.querySelector(`.ccd-item[data-line="${line}"]`);
    if (!row) return;
    const qtyEl = row.querySelector('.ccd-qty-value');
    if (!qtyEl) return;

    const current = Number(qtyEl.textContent) || 0;
    const next = current + delta;
    if (next < 1) {
      setQty(line, 0);
    } else {
      setQty(line, next);
    }
  }

  window.updateHeaderCartBubble = function() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const cartIconBubble = document.getElementById('cart-icon-bubble');
        if (!cartIconBubble) return;

        const cartCountBubble = cartIconBubble.querySelector('.cart-count-bubble');
        
        // Update the cart count
        if (cart.item_count > 0) {
          // Create bubble if it doesn't exist
          if (!cartCountBubble) {
            const newBubble = document.createElement('div');
            newBubble.className = 'cart-count-bubble';
            newBubble.innerHTML = `<span aria-hidden="true">${cart.item_count}</span><span class="visually-hidden">${cart.item_count} items</span>`;
            cartIconBubble.appendChild(newBubble);
          } else {
            cartCountBubble.style.display = 'block';
            const cartCountSpan = cartCountBubble.querySelector('span[aria-hidden="true"]');
            if (cartCountSpan) {
              cartCountSpan.textContent = cart.item_count;
            }
          }
        } else {
          // Hide bubble if cart is empty
          if (cartCountBubble) {
            cartCountBubble.style.display = 'none';
          }
        }
      })
      .catch(e => {
        console.error('Error updating header cart bubble:', e);
      });
  }

  // Close interactions
  if (closeBtn) {
    closeBtn.addEventListener('click', closeDrawer);
  }

  overlay.addEventListener('click', (e) => {
    if (e.target === overlay) {
      closeDrawer();
    }
  });

  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', () => {
      window.location.href = '/checkout';
    });
  }

  // Global helper so product-hero.js can call it
  window.CustomCart = window.CustomCart || {};
  window.CustomCart.openAndRefresh = fetchCartAndOpen;

  // Open cart drawer when any cart icon is clicked
  const cartTriggers = document.querySelectorAll('[data-open-cart]');
  cartTriggers.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      if (window.CustomCart && typeof window.CustomCart.openAndRefresh === 'function') {
        window.CustomCart.openAndRefresh();
      }
    });
  });
});
